import React from "react";
import { Navigate } from "react-router-dom";

const ShowHistoryComponent = React.lazy(
  () => import("../../../../../components/history/components/show/page"),
);
const ListHistoryComponent = React.lazy(
  () => import("../../../../../components/history/components/list/page"),
);

export const historyRoute = [
  {
    path: "show",
    element: <ShowHistoryComponent />,
  },
  {
    path: "list",
    element: <ListHistoryComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/stockify/history/show" />,
  },
];
